module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "spouse-form"
  }, [_c('div', {
    staticClass: "panel__block"
  }, [_c('h2', [_vm._v(_vm._s(_vm.setFormTitle) + " "), (_vm.showClearButton()) ? _c('button', {
    staticClass: "clear-button",
    on: {
      "click": _vm.clearSpouse
    }
  }, [_vm._v("×")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "picker-wrap"
  }, [_c('ClientPicker', {
    attrs: {
      "id": "spouse-picker",
      "field": _vm.setField,
      "context": "spouse"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-11f75e96!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SpouseForm.vue
// module id = 311
// module chunks = 0